// UTF-8

$(function(){
	var slick1 = $('.topslider').slick({
		dots:true,
		infinite: true,
		swipeToSlide: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		//arrows: false,
		autoplay:true,
		fade: false,
		responsive: [
		{
			breakpoint: 768,
			settings: {
				variableWidth:false,
				slidesToShow: 1,
				arrows: false,
			}
		}
	]
	});

	$('.rank_wrap > .rank_box:first-child').wrap('<div class="rank_top">');
	$('.rank_wrap > .rank_box').wrapAll('<div class="rank_second">');
});
